export default __webpack_public_path__ + "static/media/history_1990_03.898922c9.png";